export function arrayOperator(chunks) {
  return chunks.flat();
}

export function objectOperator(chunks) {
  return Object.keys(chunks).reduce((acc, key) => {
    const data = chunks[key];
    const chunk =
      typeof data === 'object' && !Array.isArray(data) && data !== null
        ? data
        : { [key]: data };

    return Object.assign(acc, chunk);
  }, {});
}
